import { dew as _MappingRuleTypeDew } from "./MappingRuleType";
import { dew as _MappingRuleConfigDew } from "./MappingRuleConfig";
import { dew as _MappingRuleBaseDew } from "./MappingRuleBase";
import { dew as _MappingRuleOneToOneDew } from "./MappingRuleOneToOne";
import { dew as _MappingRuleDew } from "./MappingRule";
import { dew as _MappingRuleResponseDew } from "./MappingRuleResponse";
import { dew as _MappingRulesResponseDew } from "./MappingRulesResponse";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function () {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });
  var __exportStar = exports && exports.__exportStar || function (m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  __exportStar(_MappingRuleTypeDew(), exports);
  __exportStar(_MappingRuleConfigDew(), exports);
  __exportStar(_MappingRuleBaseDew(), exports);
  __exportStar(_MappingRuleOneToOneDew(), exports);
  __exportStar(_MappingRuleDew(), exports);
  __exportStar(_MappingRuleResponseDew(), exports);
  __exportStar(_MappingRulesResponseDew(), exports);
  return exports;
}